import { createFileRoute, redirect } from "@tanstack/react-router";

/** The old address of Move-in packets' Templates tab. */
export const Route = createFileRoute(
  "/_authenticated/_administration/settings/admission-packet-templates",
)({
  beforeLoad: () => {
    throw redirect({ to: "/settings/move-in/templates", replace: true });
  },
});
